import {
  WSEmptyState,
  WSFilters,
  WSInfiniteScroll,
  WSList
} from "@wingspanhq/fe-component-library";
import { useMemo } from "react";
import { useHistory } from "react-router-dom";
import { useUserId } from "../../../../query/hooks/helpers";
import { useQueryWorkLogs } from "../../../../query/workLog/queries/useQueryWorkLogs";
import { WSQueries } from "../../../../query/WSQuery";
import { useUrlQuery } from "../../../../shared/hooks/useUrlQuery";
import { getPathWorkLogPayeeDetails } from "../../paths";
import { TableWorkLogsPayeeView } from "./TableWorkLogsPayeeView";
import { useBuildConfig } from "./filters/config";
import { createListRequest } from "./filters/request";
import { Filter } from "./filters/types";

type Props = {
  status?: Filter["status"];
};

export const FilterableTableWorkLogsPayeeView: React.FC<Props> = props => {
  const userId = useUserId();
  const history = useHistory();

  const { urlQuery, setUrlQuery } = useUrlQuery();

  const request = useMemo(
    () =>
      createListRequest(userId, {
        status: props.status,
        ...urlQuery.filter
      }),
    [userId, props.status, urlQuery.filter]
  );

  const filtersConfig = useBuildConfig();

  const queryWorkLogs = useQueryWorkLogs(request);

  const hasFilters = useMemo(
    () => Object.keys(urlQuery.filter || {}).length > 0,
    [urlQuery.filter]
  );

  return (
    <WSList gap="2XL">
      <WSFilters<Filter>
        values={urlQuery.filter}
        onFilter={newValue => {
          setUrlQuery({ filter: newValue });
        }}
        primaryFilters={filtersConfig}
      />

      <WSQueries queries={{ queryWorkLogs }}>
        {({ queryWorkLogsData }) =>
          hasFilters && queryWorkLogsData.length === 0 ? (
            <WSEmptyState
              py="3XL"
              hasBorder
              bgColor="gray"
              type="search"
              title="No results found"
              description="Try adjusting your search or filter to find what you're looking for."
            />
          ) : queryWorkLogsData.length === 0 ? (
            <WSEmptyState
              py="3XL"
              hasBorder
              bgColor="gray"
              type="tasks"
              title="No work logs yet"
              description="Once a work log is created, it will appear here."
            />
          ) : (
            <WSInfiniteScroll
              mt="M"
              onLoad={() => queryWorkLogs.fetchNextPage()}
              loadMore={queryWorkLogsData.length > 0}
              endOfList={!queryWorkLogs.hasNextPage}
              loading={!!queryWorkLogs.isFetchingNextPage}
            >
              <TableWorkLogsPayeeView
                workLogs={queryWorkLogsData}
                onRowClick={workLog => {
                  history.push(getPathWorkLogPayeeDetails(workLog.workLogId));
                }}
              />
            </WSInfiniteScroll>
          )
        }
      </WSQueries>
    </WSList>
  );
};
